import { render, staticRenderFns } from "./collectionloan.vue?vue&type=template&id=164ae849&"
import script from "./collectionloan.vue?vue&type=script&lang=js&"
export * from "./collectionloan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports